/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { createContext } from 'react';

// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Grid container context__
 *
 * A grid container context {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */
export const GridContainerContext: import('react').Context<boolean> = createContext(false);
